import {MvsCrudService} from "../../../../../../../core/shared/service/crud/mvs-crud.service";
import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageComponent} from "../../../../../../../core/shared/mvs-page/page.component";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../../core/shared/widget/widget-data-param";
import {QlQueryDto} from "../../../../../../../core/shared/ql/data/dto/ql-query.dto";
import {QlRequestDto} from "../../../../../../../core/shared/ql/data/dto/ql-request.dto";
import {QlExportPipeDto} from "../../../../../../../core/shared/ql/data/dto/ql-export-pipe.dto";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {Sorting} from "../../../../../../../core/shared/misc/sorting";
import {ObjectIdentifierData} from "../../../../../../../core/shared/basic/object-identifier-data";
import {ObjectRequestList} from "../../../../../../../core/shared/dto/object/request/object-request-list";
import {DtoList} from "../../../../../../../core/shared/dto/dto.list";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {EuUserAddedInsuranceDocumentDto} from "../../../../../model/dto/entity/eu-user-added-insurance-document.dto";
import {MvsObjectNavigationService} from "../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsObjectNavigationEntry} from "../../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";

@Component({
    selector: 'mvs-eu-user-added-insurance-pending',
    templateUrl: './eu-user-added-insurance-pending.component.html',
    standalone: false
})
export class EuUserAddedInsurancePendingComponent extends PageComponent implements OnInit, AfterViewInit, OnDestroy {

    userAddedInsuranceDocumentService: MvsCrudService;
    initialized: boolean;
    defaultLabel: string = 'Vom Kunden erfasste Verträge';
    widgetUserAddedInsurancePending: WidgetData;

    customerListWidget: WidgetData;
    insuranceDetailsWidget: WidgetData;
    selectedCustomerId: number | null = null;
    selectedCustomerData: ObjectIdentifierData | null = null;
    customerUsersDtoList: DtoList;

    // Copied from cr-customer-registration-navigation.component.ts for document-opening functionality
    selectedUserAddedInsurance: ObjectIdentifierData;
    userAddedInsuranceDocumentDtoList: DtoList<EuUserAddedInsuranceDocumentDto>;

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected navigationService: MvsObjectNavigationService
    ) {
        super(route, coreService);

        this.userAddedInsuranceDocumentService = this.coreService.getCrudService("eu.EuUserAddedInsuranceDocument");
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    initComponent() {
        this.refreshComponent();
    }

    refreshComponent() {
        this.uiRefresh();
        this.initialized = true;
    }

    uiRefresh() {
        const qlQueryDto: QlQueryDto = {
            name: 'eu.user.added.insurance.pending',
            type: 'view',
            start: {
                type: 'entity',
                name: 'eu.EuUserAddedInsurance',
                as: 'uai',
                joins: [
                    {
                        type: 'entity',
                        name: 'user',
                        as: 'u',
                        joinType: 'left',
                        joins: [
                            {
                                type: 'entity',
                                name: 'cr.CustomerUser#user',
                                as: 'cu',
                                joinType: 'left',
                                joins: [
                                    {
                                        type: 'entity',
                                        name: 'customer',
                                        as: 'c',
                                        joinType: 'left',
                                        joins: [
                                            {
                                                type: 'entity',
                                                name: 'registration',
                                                as: 'r',
                                                joinType: 'left'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                ]
            },
            fixedFilters: [
            FilterCriteria.create(
                'uai.internalStatus',
                FilterCriteria.cOperatorIn,
                [0, 1]
            ),
            FilterCriteria.createOr(
                FilterCriteria.create(
                    'r.registrationStatusInternal',
                    FilterCriteria.cOperatorIsNull
                ),
                // backend eu.logic.EuRegistrationStatusInternal: 0 pending, 1 in_processing, 2 follow_up
                FilterCriteria.create(
                    'r.registrationStatusInternal',
                    FilterCriteria.cOperatorInNot,
                    [0, 1, 2]
                )
            )
        ],
        sortings: [
            new Sorting('uai.createdDate', false)
        ]
        };

        const qlExportPipeDto: QlExportPipeDto = {
            name: 'eu.user.added.insurance.pending',
            type: 'simple',
            simpleQuery: 'eu.user.added.insurance.pending',
            settings: {
                includeForm: true,
                includeCount: true,
                includeRuntimeMetrics: false,
            }
        };

        const qlRequestDto = new QlRequestDto();
        qlRequestDto.queries = [qlQueryDto];
        qlRequestDto.pipes = [qlExportPipeDto];

        this.widgetUserAddedInsurancePending = WidgetFactory.createWidgetList(
            'eu.user.added.insurance.pending',
            'Vom Kunden erfasste Verträge',
            'table',
            'list',
            'ql',
            'eu.EuUserAddedInsurance',
            'Keine Daten vorhanden',
            qlRequestDto,
            WidgetDataParam.create('size', 'S'),
            WidgetDataParam.create('objectWidget', 'data')
        );

        this.customerListWidget = this.createCustomerListWidget();
    }

    private createCustomerListWidget(): WidgetData {
        // Original query - do NOT modify this
        const qlQueryDto: QlQueryDto = {
            name: 'eu.user.added.insurance.pending',
            type: 'view',
            start: {
                type: 'entity',
                name: 'eu.EuUserAddedInsurance',
                as: 'uai',
                joins: [
                    {
                        type: 'entity',
                        name: 'user',
                        as: 'u',
                        joinType: 'left',
                        joins: [
                            {
                                type: 'entity',
                                name: 'cr.CustomerUser#user',
                                as: 'cu',
                                joinType: 'left',
                                joins: [
                                    {
                                        type: 'entity',
                                        name: 'customer',
                                        as: 'c',
                                        joinType: 'left',
                                        joins: [
                                            {
                                                type: 'entity',
                                                name: 'registration',
                                                as: 'r',
                                                joinType: 'left'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                ]
            },
            fixedFilters: [
                FilterCriteria.create(
                    'uai.internalStatus',
                    FilterCriteria.cOperatorIn,
                    [0, 1]
                ),
                FilterCriteria.createOr(
                    FilterCriteria.create(
                        'r.registrationStatusInternal',
                        FilterCriteria.cOperatorIsNull
                    ),
                    // backend eu.logic.EuRegistrationStatusInternal: 0 pending, 1 in_processing, 2 follow_up
                    FilterCriteria.create(
                        'r.registrationStatusInternal',
                        FilterCriteria.cOperatorInNot,
                        [0, 1, 2]
                    )
                )
            ],
            sortings: [
                new Sorting('uai.createdDate', false)
            ]
        };

        const widget = WidgetFactory.createWidgetListQl(
            'eu.user.added.insurance.pending',
            'Kunden',
            'selectable',
            qlQueryDto
        );

        // Configure selectable widget following Ticket Typ tab pattern (tm/config → ticket-type.page.ts)
        widget.uiComponent = 'selectable';
        widget.setParam(WidgetDataParam.create('attributeToDisplay', 'c.calculatedName'));

        // Deduplication: Store custom data processor on widget (applied after query returns)
        (widget as any)['dataProcessor'] = this.deduplicateCustomers.bind(this);

        return widget;
    }

    /**
     * Deduplicates customer list based on customer ID
     * Applied after query data is received to ensure only unique customers are displayed
     * @param data - The raw data array from the query result
     * @returns Array of unique customers (first occurrence of each customer ID is kept)
     */
    private deduplicateCustomers(data: any[]): any[] {
        if (!data || !Array.isArray(data)) {
            return data;
        }

        const seenCustomerIds = new Set<number>();
        const uniqueData: any[] = [];

        for (const item of data) {
            // Extract customer ID - the data structure has c.id directly in the item
            const customerId = item?.['c.id'];

            if (customerId !== undefined && customerId !== null) {
                if (!seenCustomerIds.has(customerId)) {
                    seenCustomerIds.add(customerId);
                    uniqueData.push(item);
                }
            } else {
                // If no customer ID found, include the item (fallback behavior)
                uniqueData.push(item);
            }
        }

        return uniqueData;
    }

    onCustomerSelect(selectedObject: ObjectIdentifierData | ObjectIdentifier) {
        this.selectedCustomerData = selectedObject as ObjectIdentifierData;

        // Customer ID is in the data object as 'c.id'
        if (this.selectedCustomerData.data && this.selectedCustomerData.data['c.id']) {
            this.selectedCustomerId = this.selectedCustomerData.data['c.id'];
        } else {
            this.selectedCustomerId = selectedObject.objectId;
        }

        this.refreshInsuranceDetailsWidget();
    }

    private refreshInsuranceDetailsWidget() {
        if (!this.selectedCustomerId) {
            this.insuranceDetailsWidget = null;
            return;
        }

        const customerUserService = this.coreService.getCrudService('cr.CustomerUser');
        customerUserService.list(
            ObjectRequestList.createBasic(
                false,
                [FilterCriteria.create('customer', FilterCriteria.cOperatorEqual, this.selectedCustomerId)],
                null
            )
        ).subscribe((res: DtoList) => {
            this.customerUsersDtoList = res;
            console.log('Customer users response:', res);
            console.log('Customer users entries:', res?.entries);
            this.insuranceDetailsWidget = this.createInsuranceDetailsWidget();
        });
    }

    private createInsuranceDetailsWidget(): WidgetData {
        // Check if there are any customer users to avoid empty WHERE clause
        if (!this.customerUsersDtoList?.entries || this.customerUsersDtoList.entries.length === 0) {
            console.log('No customer users found, returning empty widget');
            return WidgetFactory.createWidgetList(
                'eu.user.added.insurance.customer.details',
                'Vom Kunden erfasste Verträge',
                'table',
                'list',
                'ql',
                '',
                'Keine Versicherungen für diesen Kunden gefunden',
                null,
                WidgetDataParam.create('size', 'M'),
                WidgetDataParam.create('objectWidget', 'data')
            );
        }

        console.log('Creating filter from entries:', this.customerUsersDtoList.entries);
        const filterCriteria: FilterCriteria = FilterCriteria.createOrFromArray(
            'e.userId',
            'userDtoId',
            this.customerUsersDtoList.entries
        );
        console.log('Created filterCriteria:', filterCriteria);
        console.log('Filter has or entries:', filterCriteria.or?.length);

        // Double-check the filter is valid before using it
        if (!filterCriteria.or || filterCriteria.or.length === 0) {
            console.log('Filter has no OR entries, returning empty widget');
            return WidgetFactory.createWidgetList(
                'eu.user.added.insurance.customer.details',
                'Vom Kunden erfasste Verträge',
                'table',
                'list',
                'ql',
                '',
                'Keine Versicherungen für diesen Kunden gefunden',
                null,
                WidgetDataParam.create('size', 'M'),
                WidgetDataParam.create('objectWidget', 'data')
            );
        }

        return WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'eu.user.added.insurance.customer.details',
            'Vom Kunden erfasste Verträge',
            'eu.EuUserAddedInsurance',
            [filterCriteria],
            [new Sorting('e.createdDate', false)],
            WidgetDataParam.create('size', 'M'),
            WidgetDataParam.create('objectWidget', 'data')
        );
    }

    ngOnDestroy(): void {
    }

    /**
     * Apply deduplication to customer list widget data after widget loads
     * This ensures duplicate customers (caused by multiple insurances per customer) are filtered out
     */
    ngAfterViewInit(): void {
        // Apply deduplication after widget has loaded data
        setTimeout(() => {
            this.applyCustomerDeduplication();
        }, 100);
    }

    /**
     * Applies deduplication to the customer list widget data
     * Reads the widget's transient data, deduplicates it, and sets it back
     */
    private applyCustomerDeduplication(): void {
        if (this.customerListWidget?.dataTransient?.data) {
            const rawData = this.customerListWidget.dataTransient.data;
            const deduplicatedData = this.deduplicateCustomers(rawData);
            this.customerListWidget.dataTransient.data = deduplicatedData;
        }
    }

    // Copied from cr-customer-registration-navigation.component.ts - handleObjectSelect method
    // Handles selecting a user added insurance and loading associated documents
    handleObjectSelect(object: ObjectIdentifierData | ObjectIdentifier) {
        this.selectedUserAddedInsurance = object as ObjectIdentifierData;
        const filterCriteria = FilterCriteria.create('userAddedInsurance', FilterCriteria.cOperatorEqual, object.objectId);

        this.userAddedInsuranceDocumentService.list(ObjectRequestList.createBasic(false, [filterCriteria], null)).subscribe(res => {
            this.userAddedInsuranceDocumentDtoList = res;
        })
    }

    // Copied from cr-customer-registration-navigation.component.ts - onDocumentSelect method
    // Handles opening a document in the left panel when clicked
    onDocumentSelect(document: EuUserAddedInsuranceDocumentDto) {
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry(
            "dm.DmDocument",
            document.documentDtoId,
            null,
            "Dokument " + document.name,
            null,
            null,
            MvsObjectNavigationActionEnum.any);

        this.navigationService.navigateTo(mvsObjectNavigationEntry, "left");
    }
}
